import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const DemographicJPFitmentScenario = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const currentPath = location.pathname;
    const fullState = location.state || {};

    return (
        <div className="w-full flex justify-center my-4">
            <div className="flex items-center mt-6 gap-1 p-1 bg-white border border-gray-300 rounded-lg shadow-sm">

                {/* Demographic Assessment */}
                <button
                    onClick={() =>
                        navigate("/assessment-configuration", {
                            state: {
                                ...fullState,
                                type: "demographic",
                            },
                        })
                    }
                    className={`px-4 py-1.5 rounded-md text-[13px] font-semibold transition-all duration-200
                        ${
                            currentPath === "/assessment-configuration"
                                ? "bg-red-50 text-red-600"
                                : "text-[#535659] hover:bg-gray-100"
                        }`}
                >
                    Demographic Assessment
                </button>

                {/* JP Fitment Test */}
                <button
                    onClick={() =>
                        navigate("/jp-fitment-test", {
                            state: {
                                ...fullState,
                                type: "jp-fitment",
                            },
                        })
                    }
                    className={`px-4 py-1.5 rounded-md text-[13px] font-semibold transition-all duration-200
                        ${
                            currentPath === "/jp-fitment-test"
                                ? "bg-red-50 text-red-600"
                                : "text-[#535659] hover:bg-gray-100"
                        }`}
                >
                    JP Fitment Test
                </button>

                {/* Scenario-Based Assessment */}
                <button
                    onClick={() =>
                        navigate("/scenario-based-assessment", {
                            state: {
                                ...fullState,
                                type: "scenario",
                            },
                        })
                    }
                    className={`px-4 py-1.5 rounded-md text-[13px] font-semibold transition-all duration-200
                        ${
                            currentPath === "/scenario-based-assessment"
                                ? "bg-red-50 text-red-600"
                                : "text-[#535659] hover:bg-gray-100"
                        }`}
                >
                    Scenario-Based Assessment
                </button>

            </div>
        </div>
    );
};

export default DemographicJPFitmentScenario;